// Sentry configuration for React + Vite
// https://docs.sentry.io/platforms/javascript/guides/react/

import * as Sentry from "@sentry/react"

export const initSentry = () => {
  const dsn = import.meta.env.VITE_SENTRY_DSN || ""

  if (!dsn) {
    console.info("[Sentry] DSN not configured, skipping initialization")
    return
  }

  Sentry.init({
    dsn,

    // Add optional integrations for additional features
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],

    // Define how likely traces are sampled
    tracesSampleRate: import.meta.env.MODE === "production" ? 0.1 : 1.0,

    // Define how likely Replay events are sampled
    replaysSessionSampleRate: 0.1,

    // Define how likely Replay events are sampled when an error occurs
    replaysOnErrorSampleRate: 1.0,

    // Enable sending user PII (Personally Identifiable Information)
    // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
    sendDefaultPii: true,

    // Environment configuration
    environment: import.meta.env.MODE || "development",
  })
}

export { Sentry }
